import { render, staticRenderFns } from "./segmented-control.vue?vue&type=template&id=103e907a&scoped=true&"
import script from "./segmented-control.vue?vue&type=script&lang=js&"
export * from "./segmented-control.vue?vue&type=script&lang=js&"
import style0 from "./segmented-control.vue?vue&type=style&index=0&id=103e907a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103e907a",
  null
  
)

export default component.exports